export default class ChangedLeaguesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.leagues === undefined || content.leagues.change === undefined) {
            return;
        }

        const leagues = content.leagues.change;

        for (let i = 0; i < leagues.length; i++) {
            const league = leagues[i];

            const key = this._modelKeyRepository.getLeagueKey(league.id);

            leagues[i] = Object.assign({
                name: league.n,
                priority: league.p
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/ChangedLeaguesModifier.js